import { tryParseNumber } from '~/utils';
import { QueryParameterSchema } from '../../context/QueryParameterContext';

export const pageSizeParameter: QueryParameterSchema<'pageSize'> = {
  getValue: ({ parameters }) => parameters.pageSize,
  getDefaultValue: ({ defaultParameters }) => defaultParameters.pageSize || 10,

  toUrlSearchParams: ({ value }) => ({ 'page[size]': `${value}` }),
  toSearchQuery: ({ value }) => ({ 'page[size]': value }),
  fromUrlSearchParams: ({ urlSearchParams, defaultValue }) => ({
    pageSize: tryParseNumber(urlSearchParams.get('page[size]')) || defaultValue,
  }),
  sanitize: ({ staticProps, value, defaultValue }) => {
    if (value && staticProps.referenceData.pageSizes.some((size) => size === value)) return { pageSize: value };
    return { pageSize: defaultValue };
  },
};
